import {
  selectLeprechaunsStealCoinsActions,
  selectPendingManeuverActions,
  selectPendingMovementActions,
  selectPendingShootingActions
} from "../../../redux/reducers/sharedStateReducer/selectors";

// Признаки «отряд уже обработан на этапе» — по тем же данным, по которым поле
// рисует метку «уже ходил» (HexGridRenderer.renderUnit)

// Перемещение: отряд переместился (в том числе необратимо из-за ловушки
// Гоблинов) или украл монеты (Лепреконы: кража — вместо перемещения)
export const checkIfUnitMovementProcessed = (state, unit) => {
  const pendingMovementActions = selectPendingMovementActions(state) || [];
  if (pendingMovementActions.some((action) => action.unitId === unit.id)) {
    return true;
  }
  const stealCoinsActions = selectLeprechaunsStealCoinsActions(state) || [];
  return stealCoinsActions.some((action) => action.unitId === unit.id);
};

// Способности: флаг общий для Суккубов и Гоблинов (см. configs/units.js)
export const checkIfUnitAbilityProcessed = (state, unit) => !!unit.hasUsedAbilityThisWarPhase;

// Стрельба: выстрел заявлен на этом этапе (hasShotThisWarPhase ставится только
// при применении выстрелов в конце этапа)
export const checkIfUnitShootingProcessed = (state, unit) => {
  const pendingShootingActions = selectPendingShootingActions(state) || [];
  return pendingShootingActions.some((action) => action.shooterUnitId === unit.id);
};

export const checkIfUnitManeuverProcessed = (state, unit) => {
  const pendingManeuverActions = selectPendingManeuverActions(state) || [];
  return pendingManeuverActions.some((action) => action.unitId === unit.id);
};
